import type { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import {
  createResearchAction,
  getEventLogAction,
  getResearchResultAction,
} from "./actions";
import { ResearchState } from "./types";

export function createResearchReducerBuilder(
  builder: ActionReducerMapBuilder<ResearchState>
) {
  builder.addCase(createResearchAction.pending, (state) => {
    state.isResearchingStart = true;
  });
  builder.addCase(createResearchAction.fulfilled, (state, action) => {
    state.researchValue = action.payload;
    state.isResearchingStart = false;
  });
  builder.addCase(createResearchAction.rejected, (state) => {
    state.isResearchingStart = false;
  });
}

export function getEventLogReducerBuilder(
  builder: ActionReducerMapBuilder<ResearchState>
) {
  builder.addCase(getEventLogAction.fulfilled, (state, action) => {
    if (!action.payload) return;
    const { updatedValue, selectedId } = action.payload;
    state.researchValue = updatedValue;
  });
}

export function getResearchResultReducerBuilder(
  builder: ActionReducerMapBuilder<ResearchState>
) {
  builder.addCase(getResearchResultAction.fulfilled, (state, action) => {
    if (!action.payload) return;
    const { updatedValue, selectedId } = action.payload;
    state.researchValue = updatedValue;
  });
}
